import React from "react";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import { Calendar, X } from "lucide-react";

const DateRangeFilter = ({
  startDate,
  endDate,
  onChange,
  onClear,
  label = "Date Range",
}) => {
  const handleStartDateChange = (value) => {
    if (endDate && new Date(value) > new Date(endDate)) {
      // Ne pas permettre une date de début après la date de fin
      return;
    }
    onChange(value, endDate);
  };

  const handleEndDateChange = (value) => {
    if (startDate && new Date(value) < new Date(startDate)) {
      // Ne pas permettre une date de fin avant la date de début
      return;
    }
    onChange(startDate, value);
  };

  return (
    <SoftBox sx={{ position: "relative", minWidth: "240px" }}>
      <SoftBox sx={{ display: "flex", flexDirection: "column", gap: 0.5 }}>
        <SoftBox
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1,
            border: "1px solid #E7EBF0",
            borderRadius: "8px",
            padding: "8px 12px",
            background: "#fff",
            transition: "all 0.2s ease",
            "&:hover": {
              borderColor: "#B0C4DE",
            },
            position: "relative",
          }}
        >
          <Calendar size={16} color="#5D6E7E" />

          <SoftBox
            sx={{
              display: "flex",
              gap: "6px",
              alignItems: "center",
              flex: 1,
            }}
          >
            <input
              type="date"
              value={startDate}
              onChange={(e) => handleStartDateChange(e.target.value)}
              style={{
                border: "none",
                outline: "none",
                fontSize: "14px",
                color: "#5D6E7E",
                flex: 1,
                fontFamily: "inherit",
                background: "transparent",
              }}
              max={endDate || undefined}
            />

            <SoftTypography
              variant="caption"
              fontWeight="medium"
              sx={{ fontSize: "14px", color: "#5D6E7E" }}
            >
              -
            </SoftTypography>

            <input
              type="date"
              value={endDate}
              onChange={(e) => handleEndDateChange(e.target.value)}
              style={{
                border: "none",
                outline: "none",
                fontSize: "14px",
                color: "#5D6E7E",
                flex: 1,
                fontFamily: "inherit",
                background: "transparent",
              }}
              min={startDate || undefined}
            />
          </SoftBox>

          {(startDate || endDate) && (
            <X
              size={16}
              color="#5D6E7E"
              style={{ cursor: "pointer" }}
              onClick={onClear}
            />
          )}
        </SoftBox>
      </SoftBox>
    </SoftBox>
  );
};

export default DateRangeFilter;
